import request from "@/utils/request"
import qs from 'qs'
import { md5 } from "@/utils/md5.js";
import { keysort, getstring, config } from "@/utils/common.js";
export function member_id_login(query) {//获取用户信息
    return request({
        // apiredoxon_redoxon
        // emc_member
        url: '/openapi/emc_passport/member_id_login',
        method: 'POST',
        data: qs.stringify(query)
    })
}



export function treasure_index(query) {//首页
    return request({
        // apiredoxon_redoxon
        // emc_member
        url: '/openapi/emc_member/treasure_index',
        method: 'POST',
        data: qs.stringify(query)
        // data:"member_id=5302452&timestamp=1635409393&session=mobiles-117_35_118_142-6172611005500033766230&appid=ykxcx&sign=32c5b03ca1a5a565c881731323573645"
    })
}
export function treasure_get_chance(query) {//打开||转发
    return request({
        // apiredoxon_redoxon
        url: '/openapi/emc_member/treasure_get_chance',
        method: 'POST',
        data: qs.stringify(query)
    })
}
export function treasure_draw_card(query) {//获取卡片
    return request({
        // apiredoxon_redoxon
        url: '/openapi/emc_member/treasure_draw_card',
        method: 'POST',
        data: qs.stringify(query)
    })
}
//1.会员在寻宝活动中，领取关卡优惠券，实时推送

export function c_coupon11(coupon_name, coupon_id) {
    // source，source_name，coupon_name，coupon_id，openid
    let query = {
        source: window.sessionStorage.getItem("source"),//小程序||app
        openid: window.sessionStorage.getItem("openid"),//openid
        source_name: window.sessionStorage.getItem("source_name"),//怡康到家||怡康优选
        coupon_name: coupon_name,//优惠券名
        coupon_id: coupon_id,//优惠券id
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
    }
    const sign = md5(getstring(keysort(query)));
    query = {
        ...query,
        sign
    }
    // if (window.sessionStorage.getItem("openid")) {
        return request({
            url: '/openapi/emc_member/c_coupon11',
            method: 'POST',
            data: qs.stringify(query)
        })
    // } else {
    //     console.log("其他路径111")
    // }
}
// 2.会员在寻宝活动中，领取合成卡，实时推送
export function c_card11(coupon_name) {
    let query = {
        source: window.sessionStorage.getItem("source"),//小程序||app
        openid: window.sessionStorage.getItem("openid"),//openid
        source_name: window.sessionStorage.getItem("source_name"),//怡康到家||怡康优选
        coupon_name: coupon_name,//卡名
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
    }
    const sign = md5(getstring(keysort(query)));
    query = {
        ...query,
        sign
    }
    // if (window.sessionStorage.getItem("openid")) {
        return request({
            url: '/openapi/emc_member/c_card11',
            method: 'POST',
            data: qs.stringify(query)
        })
    // } else {
    //     console.log("其他路径111")
    // }
}
// 3.会员在寻宝活动中，集齐3张卡后合成成功，实时推送
export function c_compose11() {
    let query = {
        source: window.sessionStorage.getItem("source"),//小程序||app
        openid: window.sessionStorage.getItem("openid"),//openid
        source_name: window.sessionStorage.getItem("source_name"),//怡康到家||怡康优选
        coupon_name: "双11大促挖宝藏合成卡",//奖品名
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
    }
    const sign = md5(getstring(keysort(query)));
    query = {
        ...query,
        sign
    }
    if (window.sessionStorage.getItem("openid")) {
        return request({
            url: '/openapi/emc_member/c_compose11',
            method: 'POST',
            data: qs.stringify(query)
        })
    } else {
        console.log("其他路径111")
    }
}

//4.会员在寻宝活动中，领取合成后的优惠券，实时推送
export function c_final_coupon11(coupon_name, coupon_id) {
    let query = {
        source: window.sessionStorage.getItem("source"),//小程序||app
        openid: window.sessionStorage.getItem("openid"),//openid
        source_name: window.sessionStorage.getItem("source_name"),//怡康到家||怡康优选
        coupon_name: coupon_name,//优惠券名
        coupon_id: coupon_id,//优惠券id
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
    }
    const sign = md5(getstring(keysort(query)));
    query = {
        ...query,
        sign
    }
    // if (window.sessionStorage.getItem("openid")) {
        return request({
            url: '/openapi/emc_member/c_final_coupon11',
            method: 'POST',
            data: qs.stringify(query)
        })
    // } else {
    //     console.log("其他路径111")
    // }

}
//5.会员在寻宝活动中，浏览活动页面，实时推送
export function c_view11(c_page_name, c_page_path) {
    let query = {     
        source: window.sessionStorage.getItem("source"),//小程序||app
        openid: window.sessionStorage.getItem("openid"),//openid
        source_name: window.sessionStorage.getItem("source_name"),//怡康到家||怡康优选
        c_page_name: c_page_name,//名称
        c_page_path: c_page_path,//路径
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
    }
    const sign = md5(getstring(keysort(query)));
    query = {
        ...query,
        sign
    }
    // if (window.sessionStorage.getItem("openid")) {
        return request({
            url: '/openapi/emc_member/c_view11',
            method: 'POST',
            data: qs.stringify(query)
        })
    // } else {
    //     console.log("其他路径111")
    // }
}
//6.会员在双十—专题页领取优惠券
export function c_coupon(source, source_name, coupon_name, coupon_id) {
    let query = {
        source: source,//小程序||app
        openid: window.sessionStorage.getItem("openid"),//openid
        source_name: source_name,//怡康到家||怡康优选
        coupon_name: coupon_name,//优惠券名
        coupon_id: coupon_id,//优惠券id
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
    }
    const sign = md5(getstring(keysort(query)));
    query = {
        ...query,
        sign
    }
    return request({
        url: '/openapi/emc_member/c_coupon',
        method: 'POST',
        data: qs.stringify(query)
    })
}